import type { ExternalTableSchema } from '@packages/table-builder';

export const departmentsTable: ExternalTableSchema = {
  metadata: {
    title: 'Departments',
    entity: 'department',
    subtitle: 'Current list of Wealthlane system access department.',
  },
  dataSource: {
    endpoint: '/api/customer/api/app/customer-department/customer-department-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
  },
  columns: [
    { field: 'name', header: 'Department Names', type: 'text', width: 300, sortable: true },
    { field: 'description', header: 'Description', type: 'text', width: 300 },
  ],
  actions: {
    toolbar: {
      primary: { id: 'ADD_DEPARTMENT', label: 'Add Department', icon: 'add_circle_outline' },
    },
    row: [
      { id: 'VIEW_DEPARTMENT', label: 'View' },
      { id: 'EDIT_DEPARTMENT', label: 'Edit' },
      { id: 'DELETE_DEPARTMENT', label: 'Delete', variant: 'danger' },
    ],
  },
  features: {
    search: { enabled: true, placeholder: 'Search' },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    columnPreferences: { persistenceKey: 'Departments', resizable: true, reorderable: true },
  },
};
